import React, { useEffect, useState, useCallback, useRef } from 'react';
import LeadService from '../../core/services/leadsService';
import { useNavigate } from 'react-router-dom';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Modal, Box, Typography, IconButton, Grid, Divider, TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';
import { Autocomplete } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { debounce, throttle } from 'lodash';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ScrollAnimation from 'react-animate-on-scroll';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const localizer = momentLocalizer(moment);

const Scheduling = () => {
    const navigate = useNavigate();
    const [allScheduling, setAllScheduling] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedJobValue, setSelectedJobValue] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [filters, setFilters] = useState('');
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [filtersData, setFilterData] = React.useState({});
    const abortControllerRef = useRef(null);
    const options = [
        { label: 'All', value: '' },
        { label: 'Personal Time', value: 'private' },
        { label: 'Customer Opportunity', value: 'job' },
        { label: 'Organization Lead', value: 'lead' },

    ]
    const JObOptions = [
        { label: 'Schedule a tour', value: 'Schedule a tour' },
        { label: 'Services', value: 'Services' },
        { label: 'Home valuation', value: 'valuation' },

    ]
    const HandleChangeType = async (event, newValue) => {

        setSelectedValue(newValue ? newValue.value : '')
    }
    const HandleChangeJobType = async (event, newValue) => {

        setSelectedJobValue(newValue ? newValue.value : '')
    }

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);

    };

    const handleClear = () => {
        setSearchTerm('');
        fetchScheduling();
    };

    const adjustTimeBasedOnOffset = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const GetScheduling = async (searchTerm = '', selectedValue = '', selectedJobValue = '', filters = { status: '' }, signal) => {
        try {
            setIsLoadingDetails(true);
            // const cachedData = sessionStorage.getItem('schedulingData');
            // if (cachedData) { // Implement your logic to determine freshness
            //     const parsedData = JSON.parse(cachedData);

            //     setAllScheduling(parsedData);
            //     setIsLoadingDetails(false);
            //     toast.success("session storage data");
            //     return;
            // } 

            const res = await LeadService.GetScheduling(searchTerm, selectedValue, selectedJobValue, filters, { signal });

            const userOffset = getUserOffset();
            if (res.data.success) {
                const formattedSchedule = res?.data?.schedule?.map(item => {
                    const isLead = item.type === 'lead';
                    const isJob = item.type === 'job';
                    const startTime = adjustTimeBasedOnOffset(item?.start_time, userOffset);
                    const endTime = adjustTimeBasedOnOffset(item?.end_time, userOffset);
                    // Check if the event spans multiple days
                    const isMultiDay = new Date(startTime).toDateString() !== new Date(endTime).toDateString();
                    return {
                        id: item?.id,
                        title: item?.title,
                        start: startTime,
                        end: endTime,
                        location: isLead ? item.lead?.location : (isJob ? item.job?.location : null),
                        customerName: isLead
                            ? `${item.lead?.customer_first_name || ''} ${item.lead?.customer_last_name || ''}`
                            : (isJob
                                ? `${item.job?.customer_first_name || ''} ${item.job?.customer_last_name || ''}`
                                : ''),
                        customerEmail: isLead ? item.lead?.customer_email : (isJob ? item.job?.customer_email : null),
                        customerPhone: isLead ? item.lead?.customer_phone : (isJob ? item.job?.customer_phone : null),
                        agentName: `${item.agent?.name || ''} ${item.agent?.last_name || ''}`,
                        agentEmail: item.agent?.email,
                        agentPhone: item.agent?.phone || null,
                        type: item?.type,
                        schedule_type: item?.schedule_type,
                        isMultiDay // Add the multi-day check here
                    };
                });
                setAllScheduling(formattedSchedule);
                // sessionStorage.setItem('schedulingData', JSON.stringify(formattedSchedule)); // Cache data if necessary

            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoadingDetails(false);
            setIsLoading(false);
        }
    };


    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetScheduling = useCallback(
        throttle((searchTerm, selectedValue, selectedJobValue, filters, signal) => {
            GetScheduling(searchTerm, selectedValue, selectedJobValue, filters, signal);
        }, 2000), []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchScheduling = useCallback(
        debounce((searchTerm, selectedValue, selectedJobValue, filters) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetScheduling(searchTerm, selectedValue, selectedJobValue, filters, abortController.signal);
        }, 500), [throttledGetScheduling]
    );

    useEffect(() => {
        fetchScheduling(searchTerm, selectedValue, selectedJobValue, filters);
    }, [searchTerm, selectedValue, selectedJobValue, filters, fetchScheduling]);

    const handleFilters = (value, name) => {

        setFilters((prev) => {
            const selectedValue = value === 'all' ? '' : value ? value.value : ''; // Use the original value for backend
            return {
                ...prev,
                [name]: selectedValue,
            };
        });
    };


    const transformText = (text) => {

        return text
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Function to handle transformations for all arrays
    const transformData = (data) => {

        return data?.map((item) => ({
            value: item,
            text: transformText(item),
        }));
    };

    const getLeadSearchData = async () => {
        try {

            const res = await LeadService.getLeadSearchDataApi();
            if (res?.data?.success) {
                const transformedStatuses = transformData(res.data.status);
                setFilterData({ status: transformedStatuses });
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getLeadSearchData();
    }, []);


    const eventStyleGetter = (event) => {
        let backgroundColor = '#3174ad';
        if (event.type === 'private') backgroundColor = 'red';
        if (event.type === 'job') backgroundColor = '#37599b';
        if (event.type === 'lead') backgroundColor = 'green';

        const style = {
            backgroundColor,
            borderRadius: '8px',
            opacity: 0.8,
            color: 'white',
            border: '0px',
            display: 'block',
            cursor: 'pointer',
            margin: '4px'

        };
        return {
            style: style
        };
    }
    const handleEventClick = (event) => {
        setSelectedEvent(event);
    };

    const handleClose = () => {
        setSelectedEvent(null);
    };
    const CustomTimeGutterHeader = () => {
        return (
            <div style={{ textAlign: 'center', padding: '8  px', fontWeight: 'bold', backgroundColor: '#fff' }}>
                Dual-Date Meeting
            </div>
        );
    };


    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingDetails && <LinearProgress />}</div>
            <ScrollAnimation animateIn='fadeIn'>
                <Box sx={{ display: 'flex', justifyContent: "start", gap: {
                    xs: '3px',
                    sm: '20px',
                    md: '30px'
                }
                , marginBottom: '20px'}}>
                        <Typography sx={{ display: 'flex', alignItems: 'center', fontSize: {
                            xs: '12px',
                            sm: '14px',
                            md: '18px'
                        } }}><FiberManualRecordIcon sx={{ color: 'red', width: {
                            xs: '12px',
                            sm: '20px',
                            md: '30px'
                        } }} />Personal Time</Typography>
                        <Typography sx={{ display: 'flex', alignItems: 'center', fontSize: {
                            xs: '12px',
                            sm: '14px',
                            md: '18px'
                        } }}><FiberManualRecordIcon sx={{ color: '#5c7dbd', width: {
                            xs: '12px',
                            sm: '20px',
                            md: '30px'
                        } }} />Customer Opportunity</Typography>
                        <Typography sx={{ display: 'flex', alignItems: 'center', fontSize: {
                            xs: '12px',
                            sm: '14px',
                            md: '18px'
                        } }}><FiberManualRecordIcon sx={{ color: 'green', width: {
                            xs: '12px',
                            sm: '20px',
                            md: '30px'
                        } }} />Organization Lead</Typography>
                    

                </Box>
                <Box sx={{ display: 'flex', justifyContent: "flex-end", marginBottom: '10px', gap: '10px', flexWrap: 'wrap' }}>
                        <Autocomplete
                            options={options}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Type" />}
                            sx={{ width: {
                                xs: '150px',
                                sm: '200px',
                                md: '300px'
                            },'& .MuiOutlinedInput-root': {
                                                            borderRadius: '12px',
                                                        }, }}
                            value={options.find(option => option.value === selectedValue) || null}
                            onChange={HandleChangeType}
                            disabled={isLoading}
                        />
                        {selectedValue === 'job' && (
                            <Autocomplete
                                options={JObOptions}
                                getOptionLabel={(JObOptions) => JObOptions.label}
                                renderInput={(params) => <TextField {...params} label="Select Opportunity Type" />}
                                sx={{ width: {
                                    xs: '150px',
                                    sm: '200px',
                                    md: '300px'
                                },'& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                }, }}
                                value={JObOptions.find(JObOptions => JObOptions.value === selectedJobValue) || null}
                                onChange={HandleChangeJobType}
                                disabled={isLoading}
                            />
                        )}
                        {selectedValue === 'lead' && (
                            <Autocomplete
                                value={selectedStatus || null}
                                onChange={(event, value) => {
                                    if (!value) {
                                        setSelectedStatus(null);
                                        setFilters((prevFilters) => ({ ...prevFilters, status: '' }));
                                    } else {
                                        setSelectedStatus(value);
                                        handleFilters(value, 'status');
                                    }
                                }}
                                options={filtersData.status || []}
                                getOptionLabel={(option) => option.text}
                                renderInput={(params) => <TextField {...params} label="Status" />}
                                sx={{ width: {
                                    xs: '150px',
                                    sm: '200px',
                                    md: '300px'
                                },'& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                }, }}
                            />
                        )}


                        <TextField
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search by name"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleClear}
                                            aria-label="clear search"
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            sx={{
                                width: {
                                    xs: '150px',
                                    sm: '200px',
                                    md: '300px'
                                },'& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                            }, }}
                        />
                    </Box>

                <Box style={{ borderRadius: '22px', background: 'white', padding: '16px', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
                    <h2>Scheduling Calendar</h2>
                    <Calendar
                        localizer={localizer}
                        dayLayoutAlgorithm="no-overlap"
                        events={allScheduling}
                        startAccessor="start"
                        endAccessor="end"
                        eventPropGetter={eventStyleGetter}
                        style={{ height: '74vh' }}
                        views={['month', 'week', 'day', 'agenda']}
                        onSelectEvent={handleEventClick}
                        components={{
                            event: ({ event }) => (
                                <div>
                                    <strong>{event.agentName}</strong><br />
                                    {/* <em>Location: {event.location}</em> */}
                                </div>
                            ),
                            agenda: {
                                event: ({ event }) => (
                                    <div style={{ border: '1px solid #ccc', marginBottom: '8px', padding: '8px', borderRadius: '4px', }}>
                                        <strong>Title: {event.title}</strong><br />
                                        <strong>Location:</strong> {event?.location}<br />
                                        <strong>Customer Name:</strong> {event?.customerName}<br />
                                        <strong>Agent Name:</strong> {event?.agentName}<br />
                                        <strong>Schedule Type</strong> {event?.schedule_type}<br />
                                        <em>{event.start.toLocaleTimeString()} - {event.end.toLocaleTimeString()}</em>
                                    </div>
                                )
                            },
                            day: {
                                event: ({ event }) => (
                                    <div style={{ fontSize: '14px' }}>
                                        {event.isMultiDay ? (
                                            <>
                                                {/* <strong style={{ fontSize: '18px' }}>Scheduling Both Dates</strong> <br /><br /> */}
                                                <strong>Agent: {event?.agentName}</strong><br />
                                                <strong>Customer: {event?.customerName}</strong><br />
                                                <em>{new Date(event.start).toLocaleString()} - {new Date(event.end).toLocaleString()}</em>
                                            </>

                                        ) : (
                                            <>
                                                <strong>{event.agentName}</strong><br />
                                                <strong>{event.customerName}</strong><br />
                                                <em>{event.start.toLocaleTimeString()} - {event.end.toLocaleTimeString()}</em>
                                            </>
                                        )}
                                    </div>
                                ),
                                timeGutterHeader: CustomTimeGutterHeader, // Custom TimeGutter Header
                            }

                        }}
                    />
                </Box>
            </ScrollAnimation>
            <Modal
                open={!!selectedEvent}
                onClose={handleClose}
                aria-labelledby="event-details-title"
                aria-describedby="event-details-description"
            >
                <Box style={{ padding: '16px', background: 'white', borderRadius: '8px', margin: 'auto', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: 'absolute', width: 'auto', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 8px 24px' }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        style={{ position: 'absolute', right: '8px', top: '8px' }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {selectedEvent && (
                        <>
                            <Typography id="event-details-title" variant="h6" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
                                {selectedEvent.title} {'  '}
                            </Typography>
                            <Typography id="event-details-description" component="div">
                                {selectedEvent.type === 'private' ? (
                                    <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <strong>Agent:</strong> {selectedEvent.agentName} ({selectedEvent.agentEmail})
                                            </Grid>
                                            <Grid item xs={12}>
                                                <strong>Type:</strong> {selectedEvent.type}
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        <Grid container spacing={2} sx={{ padding: 2, maxWidth: 500, margin: 'auto', border: '1px solid #ddd', borderRadius: 2 }}>
                                            <Grid item xs={12} md={12} sx={{display:'flex', justifyContent:'center'}}>
                                                <>{selectedEvent.start.toLocaleTimeString()} - {selectedEvent.end.toLocaleTimeString()}</>
                                            </Grid>
                                            <Divider sx={{ width: '100%', marginBottom: 2 }} />

                                            {/* Customer Details */}
                                            <Grid item xs={5} sm={5} md={5}>
                                                <Typography variant="subtitle2" color="textSecondary" fontWeight="bold">Customer Name:</Typography>
                                            </Grid>
                                            <Grid item xs={7} sm={7} md={7}>
                                                <Typography variant="body1">{selectedEvent?.customerName || '-'}</Typography>
                                            </Grid>

                                            {selectedEvent.customerEmail && (
                                                <>
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Customer Email:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.customerEmail}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            {selectedEvent.customerPhone && (
                                                <>
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Customer Phone:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.customerPhone}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            {selectedEvent.location && (
                                                <>
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Location:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.location}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            <Divider sx={{ width: '100%', marginY: 2 }} />

                                            {/* Agent Details */}
                                            {selectedEvent.agentName && (
                                                <>
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Agent Name:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.agentName}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            {selectedEvent.agentEmail && (
                                                <>
                                                    <Grid item xs={5}sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Agent Email:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.agentEmail}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            {selectedEvent.agentPhone && (
                                                <>
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Agent Phone:</Typography>
                                                    </Grid>
                                                    <Grid item xs={7} sm={7} md={7}>
                                                        <Typography variant="body1">{selectedEvent.agentPhone}</Typography>
                                                    </Grid>
                                                </>
                                            )}

                                            {/* Additional Info */}
                                            <Grid item xs={5} sm={5} md={5} >
                                                <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Type:</Typography>
                                            </Grid>
                                            <Grid item xs={7}  sm={7} md={7}>
                                                <Typography variant="body1">{selectedEvent.type || '-'}</Typography>
                                            </Grid>

                                            <Grid item xs={5} sm={5} md={5}>
                                                <Typography variant="subtitle2" color="textSecondary"fontWeight="bold">Schedule Type:</Typography>
                                            </Grid>
                                            <Grid item xs={7} sm={7} md={7}>
                                                <Typography variant="body1">{selectedEvent?.schedule_type || '-'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                            </Typography>
                        </>
                    )}
                </Box>
            </Modal>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />

        </>
    );
};

export default Scheduling;
